import React, { Fragment, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { contact, SOCIAL_MEDIA_LOGOS, STYLE_TYPE } from '../../Utils/magicStrings';
import { ContactIconWrapper } from '../Home/HomeStyle';
import { styleContextApp } from '../StyleContext';
import { ThanksText, ThanksTitle, ThanksWrapper, ThanksButton, Line, SocialMediaText } from './ThankStyle';

export const Thanks = () => {
    
    const  styleType  = useContext(styleContextApp);
    const location = useLocation();
    if(!location.state) {
        return null;
    }
    const { coverImgUrl } = location.state;
    return (    
    <Fragment>
        <Header styleType={styleType} pictures={[coverImgUrl]} hasMarginTop={false} headerHeight={584} mobileHeight={404}/>
        <ThanksWrapper styleType={styleType}>
            <ThanksTitle styleType={styleType}>THANKS!</ThanksTitle>
            <ThanksText styleType={styleType}>预约成功信息将在三个工作日内经日本巡旅确认后发送至您的邮箱，
请您留意，谢谢！</ThanksText>
            <Link to='/'>
            <ThanksButton styleType={styleType}>
                <span>返回首页</span>
            </ThanksButton>
            </Link>
        <Line styleType={styleType}/>
        <SocialMediaText  styleType={styleType}>
        将本次预约分享到您的社交软体
        </SocialMediaText>
        <ContactIconWrapper thanksMarginTop={true} styleType={styleType} marginLeft={styleType === STYLE_TYPE.MOBILE ? 32 : 66 } noMargin={true} width={styleType === STYLE_TYPE.MOBILE ? 30 :60}>
            {contact.map(e => {
                return <img data-src={SOCIAL_MEDIA_LOGOS[e]} className='lazyload' alt='' key={e} id={e}/>
            }) }
        </ContactIconWrapper>
        </ThanksWrapper>
        <Footer styleType={styleType}></Footer>
    </Fragment>);
}